<template>
  <SettingsPageLayout>
    <DetailForm
      v-if="loaded && user.unconfirmedEmail"
      title="Pending Email Change"
      description="You currently have a pending email change. Please confirm your email using the link sent to the pending email before changes will take affect."
      action="Resend Confirmation Email"
      :hidecancel="true"
      @handle-action="resendEmailConfirmation()"
    >
      <p class="sm:text-sm">{{ user.email }} -> {{ user.unconfirmedEmail }}</p>
    </DetailForm>
    <DetailForm
      v-if="loaded"
      class="mt-6"
      title="Profile"
      description="Basic information about your account with Humaniz."
      action="Save"
      hidecancel="true"
      @handle-action="updateUser"
    >
      <TextInput
        label="First Name"
        placeholder="John"
        :model-value="form.first_name"
        @update:model-value="value => (form.first_name = value)"
      />
      <TextInput
        label="Last Name"
        placeholder="Doe"
        :model-value="form.last_name"
        @update:model-value="value => (form.last_name = value)"
      />
      <TextInput label="Email" placeholder="test@example.com" :model-value="form.email" />
      <PhoneInput
        label="Mobile Phone Number"
        placeholder="+1 (281) 330 8004"
        :model-value="form.mobile_phone_number"
        @update:model-value="form.mobile_phone_number = $event"
      />
      <PasswordInput label="Password Reset" :model-value="password" @update:model-value="password = $event" />
      <PasswordInput
        label="Password Reset Confirmation"
        :model-value="password_confirmation"
        @update:model-value="password_confirmation = $event"
      />
    </DetailForm>
  </SettingsPageLayout>
</template>

<script>
import { useCurrentUserStore } from '@/stores/currentUser.ts';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';
import SettingsPageLayout from '../../layouts/SettingsPageLayout/index.vue';
import DetailForm from '../../shared/DetailForm.vue';
import { resendEmailConfirmation } from '../../../api/users.ts';
import { toast } from 'vue-sonner';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
  },
  setup() {
    const currentUserStore = useCurrentUserStore();
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { currentUserStore, loadingSpinnerStore };
  },
  data() {
    return {
      loaded: false,
      form: {
        first_name: '',
        last_name: '',
        email: '',
        mobile_phone_number: '',
      },
      // intentionally not included in form so as not to attach unless defined
      password: '',
      password_confirmation: '',
    };
  },
  computed: {
    user() {
      return this.currentUserStore.currentUser;
    },
  },
  async mounted() {
    await this.getUser();
  },
  methods: {
    async getUser() {
      await this.currentUserStore.loadCurrentUser();
      this.form = {
        first_name: this.user.firstName,
        last_name: this.user.lastName,
        email: this.user.email,
        mobile_phone_number: this.user.mobilePhoneNumber,
      };
      this.loaded = true;
    },
    async updateUser() {
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      if (this.password !== '' && this.password_confirmation !== '') {
        this.form.password = this.password;
        this.form.password_confirmation = this.password_confirmation;
      }
      await this.currentUserStore.updateUser({
        user: this.user,
        updatedUserAttributes: this.form,
      });
      this.loadingSpinnerStore.hideLocalLoadingSpinner();
      toast.success('Profile updated', {
        action: { label: 'Dismiss' },
        description: 'Your Profile was successfully updated.  Use the button below to dismiss this alert.',
      });

      if (this.user?.password !== '' && this.user?.password !== '') {
        window.location.href = '/users/sign_in';
      } else {
        await this.getUser();
      }
    },
    async resendEmailConfirmation() {
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      await resendEmailConfirmation();
      this.loadingSpinnerStore.hideLocalLoadingSpinner();
      toast.success('Confirmation email resent', {
        action: { label: 'Dismiss' },
        description: 'Please check your email for the confirmation.  Use the button below to dismiss this alert.',
      });
    },
  },
};
</script>
